<template>
    <div :class="'vue timparty-cards-image-carousel cards-image-carousel bg-light ' + (image ? 'has-image' : '')">
      

      <div class="">

        <header class="text-center" v-if="component_data.title || component_data.subtitle || component_data.description">
            <h3 class="header-title" v-if="component_data.title">{{ component_data.title }}</h3>
            <p class="header-summary" v-if="component_data.subtitle">{{ component_data.subtitle }}</p>
            <div class="header-content" v-if="component_data.description" v-html="component_data.description"></div>
        </header>

        <div class="row row-eq-height  no-gutters">
          <div v-if="image" class="image-main col-sm-6 d-flex align-items-center">
            <img :src="image" class="w-100">
          </div>

          <div :class="'cards-container ' + (image ? 'col-sm-6' : 'col-sm-12')">

            <div class="cards-image-slider-arrows d-none d-md-flex align-items-center">
              <div>
                <a href="#" @click.prevent="sliderGoto('prev')" class="d-block"><img :src="themePath('/images/arrow-left.svg')"></a>
                <a href="#" @click.prevent="sliderGoto()" class="d-block"><img :src="themePath('/images/arrow-right.svg')"></a>
              </div>
            </div>

            <section class="cards-image-slider">
              <div class="card-container"  v-for="(card,idx) in component_data.cards" v-bind:key="idx">
                <div class="card h-100">
                    <h3 class="card-title">{{ card.title }}</h3>
                    <div class="card-content" v-html="card.description"></div>
                </div>
              </div>
            </section>
          </div>
        </div>
       
      </div>
    </div>
</template>

<script>

    /* eslint-disable */ 

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import $ from 'jquery';

    export default {
      name: 'CardsImageSlider',
      mixins: [ TimPartyMixin ],
      props: {
        hideNumbers: {
          type: Boolean,
          required: false,
          default: false,
        },
        data: {
          type: Object,
          required: true, 
        },
        image: {
          type: String,
          default: '/sites/default/files/2021-04/CITYSCOOT_1_big_0.jpg',
          required: false, 
        }
      },
      data: function(){

        return {
          component_data: {},
        };
      },
      mounted: function(){
        var self = this;

        if(this.data)
          this.component_data = this.data;

         if( this.component_data.cards.length > 1){
            this.$nextTick( function(){

              var slides_to_show = self.image ? 1.5 : 2.5;

              $('.cards-image-slider').slick({
                dots: false,
                infinite: false,
                arrows: false,
                slidesToShow: slides_to_show,
                slidesToScroll: 1,
                autoplay: false,
                responsive: [
                    
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                            dots: false,
                //
                        }
                    },
                    {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                        }
                    }
                ]
              });
            });
          }
      
      },
      
      methods: {

        sliderGoto: function(dir){

          if(dir == 'prev'){
            $('.cards-image-slider').slick('slickPrev');
          }
          else{
            $('.cards-image-slider').slick('slickNext');
          }
          
        },
      
      },
      computed: {
       
      }
    }
  </script>


